import { createContext, RefObject } from 'react';

export interface MenuActionsContextValue {
  close: () => void;
  open: () => void;
}

export const MenuActionsContext = createContext<MenuActionsContextValue>({
  close: () => {},
  open: () => {},
});
